module.exports = __webpack_public_path__ + "static/media/logo.131f71d4.svg";